/**
 * SearchHighlightLayer — Paints find-in-document match highlights on top of
 * a page, positioned from documentSearch.js's page-coordinate rects.
 *
 * Composed into the SAME renderOverlay slot as PdfTextLayer (text layer
 * first, then highlights) so it shares DOM-order stacking with the other
 * per-page overlays: z-index 3, above the z-auto/0 text layer, below
 * AnnotationLayer (5).
 */
import { pageOverlayStyle } from '@/lib/pageGeometry';

export default function SearchHighlightLayer({ matches, activeMatchId, pageNum, zoom, geometry }) {
  const pageMatches = (matches || []).filter((m) => m.pageNum === pageNum);
  if (pageMatches.length === 0) return null;

  return (
    <div
      className="absolute inset-0"
      style={{ pointerEvents: 'none', zIndex: 3, ...pageOverlayStyle(geometry, zoom) }}
      aria-hidden="true"
    >
      {pageMatches.map((m) => {
        const isActive = m.id === activeMatchId;
        return (
          <div
            key={m.id}
            style={{
              position: 'absolute',
              left: `${m.rect.x * zoom}px`,
              top: `${m.rect.y * zoom}px`,
              width: `${m.rect.width * zoom}px`,
              height: `${m.rect.height * zoom}px`,
              background: isActive ? 'rgba(249, 115, 22, .55)' : 'rgba(250, 204, 21, .4)',
              outline: isActive ? '1.5px solid rgba(249, 115, 22, .9)' : 'none',
              pointerEvents: 'none',
            }}
          />
        );
      })}
    </div>
  );
}
